import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import { use } from "react";
import Sidebar from "../layout/Sidebar";
import AgentSidebar from "../layout/AgentSidebar";

const LoanCollection = () => {
  const [items, setItems] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [errors, setErrors] = useState({});
  const [activeTab, setActiveTab] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [isPaidLogModalOpen, setIsPaidLogModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    date: "",
    amount: "",
    edit_amount: " ",
    loan_id: " ",
    log_id: " ",
  });
  const [loans, setLoans] = useState([]);
  const [editLoanId, setEditLoanId] = useState(null);
  const [pendingAmount, setPendingAmount] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [allLoans, setAllLoans] = useState([]);
  const role = sessionStorage.getItem("role");
  const SidebarComponent = role === "admin" ? Sidebar : AgentSidebar;

  const [formData, setFormData] = useState({
    customer_name: "",
    scheme_name: "",
    amount: "",
    emi_amount: "",
    id: "",
    rem_amount: "",
    datevalue: "",
    loan_id: "",
    pending_due: "",
    days: "",
    pending: "",
    amountpaid: "",
    collectionagent_id: "",
    loanid: "",
    customer_id: "",
  });
  const validateField = (name, value) => {
    let error = "";

    if (name === "datevalue" && !value) {
      error = "Required";
    }

    if (name === "amountpaid") {
      if (!value) {
        error = "Required";
      } else if (parseFloat(value) < 0) {
        error = "Invalid amount";
      }
    }

    return error;
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      const emptyData = {
        customer_name: "",
        scheme_name: "",
        amount: "",
        emi_amount: "",
        id: "",
        rem_amount: "",
        datevalue: "",
        loan_id: "",
        pending_due: "",
        days: "",
        pending: "",
        amountpaid: "",
        collectionagent_id: "",
        customer_id: "",
      };

      setFormData(emptyData);
    }
  };
  const fetchLogData = async (loan_id) => {
    setModalData([]);
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const response = await axios.get(`${baseURL}/fetchData`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const fetchedData = response.data;
      console.log("Response Data: ", fetchedData);

      if (Array.isArray(fetchedData) && fetchedData.length > 0) {
        const selectedLoanEntries = fetchedData
          .filter((entry) => String(entry.loan_id) === String(loan_id))
          .map((entry) => ({
            log_id: entry.id,
            date: entry.date,
            emi_amount: entry.emi_amount,
            edit_amount: entry.edit_amount,
            loan_id: entry.loan_id,
          }));

        if (selectedLoanEntries.length > 0) {
          console.log("Selected Loan Entries: ", selectedLoanEntries);
          setModalData(selectedLoanEntries);
        } else {
          setModalData([
            { log_id: null, date: "", emi_amount: "", edit_amount: "" },
          ]);
        }
      } else {
        console.log("Invalid data or no entries found");
      }
    } catch (error) {
      console.error("Error fetching log data:", error);
    }
  };

  const handleEditClick = (loan_id) => {
    setEditLoanId(loan_id);
    fetchLogData(loan_id);
    setIsPaidLogModalOpen(true);
  };

  const groupTabsByName = (tabs) => {
    return tabs.reduce((acc, tab) => {
      if (!acc[tab.scheme_name]) {
        acc[tab.scheme_name] = [];
      }
      acc[tab.scheme_name].push(tab);
      return acc;
    }, {});
  };
  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/getScheme`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        const schemes = response.data;
        setTabs(schemes);
        if (schemes.length > 0 && !activeTab) {
          setActiveTab(schemes[0].scheme_name);
        }
      })
      .catch((error) => {
        console.error("Error fetching scheme data:", error);
      });
  }, []);

  useEffect(() => {
    if (tabs.length > 0 && !tabs.some((tab) => tab.scheme_name === activeTab)) {
      setActiveTab(tabs[0].scheme_name);
    }
    console.log("Tabs updated:", tabs);
    console.log("Active Tab:", activeTab);
  }, [tabs, activeTab]);

  useEffect(() => {
    if (role === "admin") {
      fetchItems();
    } else if (role === "agent") {
      fetchAgentItems();
    }
  }, []);

  const updateData = async (id) => {
    const item = items.find((item) => item.id === id);
    if (!item) return;

    setFormData({
      customer_name: item.customer_name,
      scheme_name: item.scheme_name,
      amount: item.amount,
      emi_amount: item.emi_amount,
      rem_amount: item.rem_amount,
      loan_id: item.loan_id,
      id: item.id,
      loanid: "",
      customer_id: item.customer_id,
    });

    const endDate = item.end_date;
    console.log("End date : ", endDate);
    const pendingDays = calculatePendingDays(endDate);
    setFormData((prevData) => ({
      ...prevData,
      days: pendingDays,
    }));

    const rem_amount = item.rem_amount;
    console.log("Remaining Amount : ", rem_amount);
    const emi_amount = item.emi_amount;
    console.log("EMI amount : ", emi_amount);
    const emi_date = item.emi_date;
    console.log("EMI date : ", emi_date);

    try {
      const accessToken = sessionStorage.getItem("access_token");
      const loansResponse = await axios.get(`${baseURL}/getAllLoans`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const loans = loansResponse.data;

      const selectedLoan = loans.find((loan) => loan.id == id);

      if (selectedLoan) {
        const selectedScheme = selectedLoan.scheme_id;
        const agent_id = selectedLoan.collectionagent_id;
        const customer_id = selectedLoan.customer_id;
        const initialProfit = selectedLoan.initial_profit;
        const amount = selectedLoan.amount;

        console.log("Selected Scheme: ", selectedScheme);
        console.log("CollectionAgent ID: ", agent_id);
        console.log("Customer ID: ", customer_id);

        if (!selectedScheme) {
          console.error(`No scheme found for loan id: ${id}`);
          return;
        }

        const accessToken = sessionStorage.getItem("access_token");
        const schemesResponse = await axios.get(`${baseURL}/getAllScheme`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const schemes = schemesResponse.data;

        const selectedData = schemes.find(
          (scheme) => scheme.id == selectedScheme
        );

        if (selectedData) {
          console.log("Selected Scheme Data: ", selectedData);

          setFormData((prevData) => ({
            ...prevData,
            collectionagent_id: agent_id,
          }));

          const value = selectedData.num;
          console.log("value : ", value);
          const daysCount = calculateDaysFromEmiDate(emi_date);
          console.log("Days Count : ", daysCount);
          const result = calculatePendingAmount(
            emi_amount,
            rem_amount,
            value,
            daysCount,
            amount
          );
          console.log("Pending Amount : ", result);
          setPendingAmount(result);
          setFormData((prevData) => ({
            ...prevData,
            pending_amount: result,
          }));

          setIsModalOpen(true);
        } else {
          console.error(
            `No matching scheme found for scheme_id: ${selectedScheme}`
          );
        }
      } else {
        console.error("No loan found with the given ID.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const calculatePendingAmount = (
    emi_amount,
    rem_amount,
    value,
    daysCount,
    amount
  ) => {
    console.log("Calculating pending amount with parameters:", {
      emi_amount,
      rem_amount,
      value,
      daysCount,
      amount,
    });

    // Extract number from value like "7 days"
    const daysValue = parseInt(value);
    const currentDuration = daysValue ? parseInt(daysCount / daysValue) : 0;
    console.log("Duration: ", currentDuration);

    const currEmiAmount = currentDuration * parseFloat(emi_amount);

    const remAmount = parseFloat(amount) - parseFloat(rem_amount);
    console.log(
      "Remaining Amount (after profit and previous payments): ",
      remAmount
    );

    const pending_amount = currEmiAmount - remAmount;
    console.log("Pending Amount: ", pending_amount);

    return pending_amount >= 0 ? parseFloat(pending_amount.toFixed(2)) : 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validateField(name, value),
    }));
  };
  const calculateDaysFromEmiDate = (emiDate) => {
    const emi = new Date(emiDate);
    const currentDate = new Date();

    emi.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const differenceInMs = currentDate - emi;

    if (differenceInMs === 0) {
      return 1;
    }

    const daysCount = Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1;

    return daysCount > 0 ? daysCount : 0;
  };

  const calculatePendingDays = (endDate) => {
    const end = new Date(endDate);
    const currentDate = new Date();
    const differenceInMs = end - currentDate;
    const pendingDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
    return pendingDays >= 0 ? pendingDays : 0;
  };

  const handleSubmit = async () => {
    console.log("Form submission started");

    setIsSubmitted(true);
    const newErrors = {};

    if (!formData.datevalue) {
      newErrors.datevalue = "Required";
    }

    if (!formData.amountpaid) {
      newErrors.amountpaid = "Required";
    }
    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }

    try {
      const loanId = formData.loan_id;
      const accessToken = sessionStorage.getItem("access_token");
      const loanResponse = await axios.get(`${baseURL}/getAllLoan`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const selectedLoan = loanResponse.data.find(
        (loan) => loan.loan_id == loanId
      );

      if (selectedLoan) {
        const loanid = selectedLoan.id;
        const remAmount = parseFloat(selectedLoan.rem_amount);
        console.log("Selected Loan ID: ", loanid);

        const amountPaid = parseFloat(formData.amountpaid);
        console.log("Amount Paid : ", amountPaid);
        console.log("Remaining Amount : ", remAmount);

        if (amountPaid > remAmount) {
          Swal.fire({
            icon: "error",
            text: "Payment amount can't exceed the remaining amount!",
            timer: 2000,
            showConfirmButton: false,
          });
          return;
        }

        const newRemAmount = remAmount - formData.amountpaid;
        console.log("Remaining Amount : ", newRemAmount);

        const accessToken = sessionStorage.getItem("access_token");
        const response = await axios.post(
          `${baseURL}/insertPayment`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        Swal.fire({
          icon: "success",
          text: "Payment updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });

        const updatedLoanData = {
          id: loanid,
          rem_amount: newRemAmount.toFixed(2),
          loan_id: loanId,
        };
        await axios.put(`${baseURL}/updateLoan`, updatedLoanData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        console.log("Loan data updated successfully!");

        toggleModal();
        if (role === "admin") {
          fetchItems();
        } else if (role === "agent") {
          fetchAgentItems();
        }
      } else {
        console.error("No loan found with the specified loan_id.");
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  const handleAmountChange = (e, index, field) => {
    const value = e.target.value;

    if (value < 0) {
      Swal.fire({
        icon: "error",
        text: "Amount cannot be negative!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    const updatedData = [...modalData];
    updatedData[index][field] = value;
    setModalData(updatedData);
  };

  useEffect(() => {
    if (tabs.length > 0 && !tabs.some((tab) => tab.scheme_name === activeTab)) {
      setActiveTab(tabs[0].scheme_name);
    }
  }, [tabs]);

  const filteredItems = items
    .filter((item) => item.scheme_name === activeTab)
    .filter((item) => {
      const search = searchQuery.toLowerCase();

      return (
        item.customer_name?.toLowerCase().includes(search) ||
        false ||
        item.collectionagent_name?.toLowerCase().includes(search) ||
        false ||
        item.scheme_name?.toLowerCase().includes(search) ||
        false ||
        item.amount?.toString().includes(search) ||
        false ||
        item.loan_id?.toString().includes(search) ||
        false ||
        item.emi_amount?.toString().includes(search) ||
        false ||
        item.rem_amount?.toString().includes(search) ||
        false
      );
    });

  const handleModalSubmit = async () => {
    const hasFilledEditAmount = modalData.some(
      (entry) => entry.edit_amount && entry.edit_amount.trim() !== ""
    );

    if (!hasFilledEditAmount) {
      Swal.fire({
        icon: "error",
        text: "Please fill in at least one edit amount!",
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    try {
      const updatedData = modalData.map((entry) => ({
        log_id: entry.log_id,
        loan_id: entry.loan_id,
        date: entry.date,
        emi_amount: entry.emi_amount,
        edit_amount: entry.edit_amount,
      }));

      const accessToken = sessionStorage.getItem("access_token");

      const response = await axios.put(
        `${baseURL}/updateLogData`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: "Data updated successfully!",
          timer: 2000,
          showConfirmButton: false,
        });

        await axios.put(`${baseURL}/updateLoanRemamount`, updatedData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (role === "admin") {
          fetchItems();
        } else if (role === "agent") {
          fetchAgentItems();
        }
        setIsPaidLogModalOpen(false);
      } else {
        console.error("Failed to update log data:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating log data:", error);
    }
  };

  const DynamicTabsFromDatabase = () => {
    const groupedTabs = groupTabsByName(tabs);

    return (
      <div className="container w-full p-4 bg-gray-50 w-auto">
        <div className="flex justify-start border-b border-gray-300 mb-4">
          {Object.keys(groupedTabs).map((schemeName) => (
            <button
              key={schemeName}
              className={`px-4 py-2 ${
                activeTab === schemeName
                  ? "text-blue-500 border-b-2 border-blue-500"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab(schemeName)}
            >
              {schemeName}
            </button>
          ))}
        </div>

        {/* Search Bar */}

        <div className="mb-4">
          <input
            type="text"
            placeholder={`Search ${
              groupedTabs[activeTab]?.[0]?.scheme_name || ""
            }`}
            className="w-full md:w-1/2 border border-gray-300 p-2 rounded focus:outline-none focus:border-blue-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>
    );
  };
  const fetchItems = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");

      const response = await axios.get(`${baseURL}/getAllLoan`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setAllLoans(response.data);
      const fetchedData = response.data;

      const dataWithPendingDays = fetchedData.map((item) => ({
        ...item,
        days: calculatePendingDays(item.end_date),
      }));
      setItems(dataWithPendingDays);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const fetchAgentItems = async () => {
    try {
      const accessToken = sessionStorage.getItem("access_token");
      const agentId = sessionStorage.getItem("agent_id");

      const response = await axios.get(`${baseURL}/getAgentLoans`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          agent_id: agentId,
        },
      });
      setAllLoans(response.data);
      const fetchedData = response.data;

      const dataWithPendingDays = fetchedData.map((item) => ({
        ...item,
        days: calculatePendingDays(item.end_date),
      }));
      setItems(dataWithPendingDays);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  return (
    <div className="bg-gray-100 flex flex-col w-full">
      <SidebarComponent />
      <main className="flex-grow p-6 w-full">
        <h2 className="text-3xl font-bold text-center mt-5">Loan Collection</h2>

        {/* Table */}
        <div className="mt-6 bg-white shadow rounded-lg p-4 ml-0 sm:ml-0 md:ml-28 lg:ml-64">
          <div className="flex overflow-x-auto border-b border-gray-300 mb-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
            {DynamicTabsFromDatabase()}
          </div>

          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-4 sm:space-y-0 mb-4">
            <div className="flex items-center space-x-2">
              {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="relative w-full sm:w-full md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                    <div className="flex justify-between items-center mb-4">
                      <h2 className="text-lg md:text-xl font-semibold">
                        Update Payment
                      </h2>
                      <button
                        onClick={toggleModal}
                        className="text-gray-600 text-2xl"
                      >
                        &times;
                      </button>
                    </div>
                    <div className="max-h-[70vh] overflow-y-auto p-2">
                      <form className="space-y-4">
                        <div className="flex flex-col items-center mb-6"></div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="block text-gray-600">
                              Loan ID
                            </label>
                            <input
                              type="text"
                              name="loan-id"
                              value={formData.loan_id || ""}
                              readonly
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Customer Name
                            </label>
                            <input
                              type="text"
                              name="customer_name"
                              value={formData.customer_name || ""}
                              readonly
                              className="border  border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Date <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="date"
                              name="datevalue"
                              value={formData.datevalue || ""}
                              onChange={handleInputChange}
                              className={`border p-2 w-full ${
                                errors.datevalue && isSubmitted
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                            />
                            {errors.datevalue && isSubmitted && (
                              <span className="text-red-500 text-sm">
                                {errors.datevalue}
                              </span>
                            )}{" "}
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Scheme Name
                            </label>
                            <input
                              type="text"
                              name="scheme_name"
                              value={formData.scheme_name || " "}
                              className="border  border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Amount
                            </label>
                            <input
                              type="text"
                              name="amount"
                              value={formData.amount || ""}
                              readonly
                              className="border  border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              EMI amount
                            </label>
                            <input
                              type="text"
                              name="emi_amount"
                              value={formData.emi_amount || ""}
                              readOnly
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>

                          <div>
                            <label className="block text-gray-600">
                              Pending Days
                            </label>
                            <input
                              type="text"
                              name="days"
                              value={formData.days || ""}
                              readonly
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-600">
                              Amount <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              name="amountpaid"
                              value={formData.amountpaid || " "}
                              onChange={handleInputChange}
                              className={`border p-2 w-full ${
                                errors.amountpaid && isSubmitted
                                  ? "border-red-500"
                                  : "border-gray-300"
                              }`}
                            />
                            {errors.amountpaid && isSubmitted && (
                              <span className="text-red-500 text-sm">
                                {errors.amountpaid}
                              </span>
                            )}
                          </div>

                          <div>
                            <label className="block text-gray-600">
                              Pending Amount
                            </label>
                            <input
                              type="text"
                              name="pending_amount"
                              value={pendingAmount !== "" ? pendingAmount : "0"}
                              readonly
                              className="border border-gray-300 rounded w-full p-2"
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4 space-x-2">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            onClick={handleSubmit}
                            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="container mx-auto p-4 bg-gray-50">
            {/* Table */}
            <div className="flex flex-col h-screen">
              <div className="overflow-x-auto">
                <table className="w-full text-left   border-collapse text-sm sm:text-xs md:text-sm lg:text-base">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="p-2 border border-gray-300 text-left">
                        Id
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Loan ID
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Customer Name
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Scheme
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Total
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        EMI
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Rem. Amount
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Pending Days
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Paid Log
                      </th>
                      <th className="p-2 border border-gray-300 text-left">
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredItems.length > 0 &&
                      filteredItems
                        .filter((item) => {
                          console.log(
                            "item.scheme_id:",
                            item.scheme_id,
                            "activeTab:",
                            activeTab
                          );
                          return item.scheme_name === activeTab;
                        })
                        .map((item) => (
                          <tr
                            key={item.id}
                            className="border-b hover:bg-gray-50"
                          >
                            <td className="p-2">{item.id}</td>
                            <td className="p-2">{item.loan_id}</td>
                            <td className="p-2">{item.customer_name}</td>
                            <td className="p-2">{item.scheme_name}</td>
                            <td className="p-2">{item.amount}</td>
                            <td className="p-2">{item.emi_amount}</td>
                            <td className="p-2">{item.rem_amount}</td>
                            <td className="p-2">{item.days}</td>
                            <td className="p-2">
                              <button
                                onClick={() => handleEditClick(item.loan_id)}
                                className="bg-yellow-300 text-black px-4 py-2 rounded"
                              >
                                Paid Log
                              </button>
                            </td>

                            <td className="p-2 space-x-3">
                              <button
                                onClick={() => {
                                  updateData(item.id);
                                }}
                                className="bg-blue-300 text-black px-4 py-2 rounded"
                              >
                                Payment
                              </button>
                            </td>
                          </tr>
                        ))}
                  </tbody>

                  {isPaidLogModalOpen && modalData.length > 0 && (
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
                      <div className="relative w-full sm:w-1/2 md:w-1/2 max-h-[70vh] overflow-y-auto bg-white rounded-lg p-4 top-12 sm:top-16 md:top-24">
                        <h2 className="text-lg md:text-xl font-semibold mb-4">
                          Edit Paid Amount
                        </h2>

                        <div className="space-y-4">
                          {modalData.map((dataItem, index) => (
                            <div
                              key={index}
                              className="flex flex-col sm:flex-row items-start sm:items-center border-b pb-4 mb-4"
                            >
                              <div className="w-full sm:w-1/3 px-2">
                                <label className="block text-sm font-medium mb-1">
                                  Date
                                </label>
                                <input
                                  type="date"
                                  value={dataItem.date || ""}
                                  readOnly
                                  className="w-full border border-gray-300 p-2 rounded"
                                />
                              </div>
                              <div className="w-full sm:w-1/3 px-2 mt-2 sm:mt-0">
                                <label className="block text-sm font-medium mb-1">
                                  Amount
                                </label>
                                <input
                                  type="text"
                                  value={dataItem.emi_amount || ""}
                                  readOnly
                                  className="w-full border border-gray-300 p-2 rounded"
                                />
                              </div>
                              <div className="w-full sm:w-1/3 px-2 mt-2 sm:mt-0">
                                <label className="block text-sm font-medium mb-1">
                                  Edit Amount
                                </label>
                                <input
                                  type="number"
                                  value={dataItem.edit_amount || ""}
                                  onChange={(e) =>
                                    handleAmountChange(e, index, "edit_amount")
                                  }
                                  className="w-full border border-gray-300 p-2 rounded"
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="flex justify-end mt-4 space-x-2">
                          <button
                            onClick={() => setIsPaidLogModalOpen(false)}
                            className="bg-gray-300 text-black px-4 py-2 rounded"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleModalSubmit}
                            className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoanCollection;
